/**
 * Sabo gifting — size / outfit exchange (one-time link).
 * Loaded from gifting-app-bootstrap when ?exchange=1&token=...
 * UI aligned with gifting-ambassador event/campaign product cards.
 */
(function (window, document) {
  'use strict';

  var params = new URLSearchParams(window.location.search);
  if ((params.get('exchange') || '').trim() !== '1' || window.SaboGiftingReCollabMode) {
    return;
  }

  var PROXY_ROOT = '/apps/gifting';
  var TYPE_SIZE = 'Size';
  var TYPE_OUTFIT = 'Outfit';

  var state = {
    session: null,
    token: null,
    selections: {},
    submitting: false,
    formValues: {
      notes: '',
      proofNotes: '',
      returnTracking: ''
    }
  };

  function prop(obj, name) {
    if (!obj) return undefined;
    if (obj[name] !== undefined && obj[name] !== null) return obj[name];
    var pascal = name.charAt(0).toUpperCase() + name.slice(1);
    return obj[pascal];
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function normalizeThumbUrl(url) {
    var src = String(url || '').trim();
    if (!src) return '';
    if (src.indexOf('//') === 0) return 'https:' + src;
    return src;
  }

  function renderThumb(url, alt, className, width, height) {
    var src = normalizeThumbUrl(url);
    if (!src) return '';
    var cls = className ? ' class="' + escapeHtml(className) + '"' : '';
    var sizeAttrs = '';
    if (width) sizeAttrs += ' width="' + width + '"';
    if (height) sizeAttrs += ' height="' + height + '"';
    return '<img' + cls + ' src="' + escapeHtml(src) + '" alt="' + escapeHtml(alt || '') + '"'
      + sizeAttrs + ' loading="lazy" decoding="async" onerror="this.style.display=\'none\'" />';
  }

  function findRoot() {
    return document.querySelector('[data-gifting-root]')
      || document.querySelector('#gifting-app')
      || document.querySelector('.gifting-page')
      || document.querySelector('[data-gifting-page]')
      || null;
  }

  function setRoot(html) {
    var root = findRoot();
    if (root) {
      root.innerHTML = html;
      root.classList.add('gifting-exchange-host');
      return root;
    }
    var main = document.querySelector('main') || document.body;
    main.innerHTML = html;
    return main;
  }

  function queryParam(name) {
    return (new URLSearchParams(window.location.search).get(name) || '').trim();
  }

  function fetchJson(url, options) {
    return fetch(url, options || {}).then(function (response) {
      return response.text().then(function (text) {
        var data;
        try {
          data = text ? JSON.parse(text) : {};
        } catch (_error) {
          throw new Error('The gifting service returned an unexpected response.');
        }
        if (!response.ok) {
          throw new Error(prop(data, 'message') || 'The gifting service could not complete this request.');
        }
        return data;
      });
    });
  }

  function renderMessage(title, body, ok) {
    var statusClass = ok ? 'is-success' : 'is-error';
    setRoot(
      '<div class="gx">' +
        '<div class="gx-shell">' +
          '<div class="gx-terminal ' + statusClass + '">' +
            '<div class="gx-status-circle" aria-hidden="true"></div>' +
            '<h1 class="gx-terminal-title">' + escapeHtml(title) + '</h1>' +
            '<p class="gx-terminal-message">' + escapeHtml(body) + '</p>' +
          '</div>' +
        '</div>' +
      '</div>'
    );
  }

  function getOrderLines(session) {
    return prop(session, 'orderLines') || [];
  }

  /**
   * Size-only links hide outfit entirely.
   * Prefer allowOutfitExchange; also honour allowedScope === SizeOnly.
   * Missing flag → size + outfit (legacy links).
   */
  function allowOutfitExchange() {
    if (!state.session) return true;
    var flag = prop(state.session, 'allowOutfitExchange');
    if (flag === false || flag === 'false' || flag === 0 || flag === '0') return false;
    var scope = String(prop(state.session, 'allowedScope') || '').trim().toLowerCase();
    if (scope === 'sizeonly') return false;
    return true;
  }

  function getCatalog(session) {
    if (!allowOutfitExchange()) return [];
    return prop(session, 'catalog') || [];
  }

  function releasesOriginalStockOnSubmit() {
    return !state.session || prop(state.session, 'releasesOriginalStockOnSubmit') !== false;
  }

  function stockReleaseDisclaimer() {
    if (releasesOriginalStockOnSubmit()) {
      return 'Submitting reserves your replacement and returns your original size to event stock. This link cannot be reused.';
    }
    return 'Submitting reserves your replacement. Your original item stays held until the SABO team closes the exchange. This link cannot be reused.';
  }

  function selectionKey(orderLineItemId) {
    return String(orderLineItemId);
  }

  function catalogKey(item) {
    return (prop(item, 'productId') || 0) + ':' + (prop(item, 'scheduleItemId') || 0);
  }

  function sizeLabel(sizes, sizeId) {
    for (var i = 0; i < (sizes || []).length; i++) {
      if (Number(prop(sizes[i], 'sizeId')) === Number(sizeId)) {
        return prop(sizes[i], 'sizeName') || String(sizeId);
      }
    }
    return sizeId ? String(sizeId) : '';
  }

  function findCatalogItem(catalog, productId, scheduleItemId) {
    for (var i = 0; i < (catalog || []).length; i++) {
      var item = catalog[i];
      if (Number(prop(item, 'productId') || 0) === Number(productId)
        && Number(prop(item, 'scheduleItemId') || 0) === Number(scheduleItemId)) {
        return item;
      }
    }
    return null;
  }

  function ensureSelection(line) {
    var key = selectionKey(prop(line, 'orderLineItemId'));
    if (!state.selections[key]) {
      state.selections[key] = {
        enabled: false,
        exchangeType: TYPE_SIZE,
        originalOrderLineItemId: prop(line, 'orderLineItemId'),
        originalProductId: prop(line, 'productId'),
        replacementProductId: prop(line, 'productId'),
        replacementScheduleItemId: 0,
        replacementSizeId: 0,
        replacementQty: prop(line, 'qty') || 1
      };
    }
    if (!allowOutfitExchange()) {
      state.selections[key].exchangeType = TYPE_SIZE;
      state.selections[key].replacementProductId = state.selections[key].originalProductId;
      state.selections[key].replacementScheduleItemId = 0;
    }
    return state.selections[key];
  }

  function loadSession(token) {
    setRoot(
      '<div class="gx">' +
        '<div class="gx-shell">' +
          '<div class="gx-loading">' +
            '<div class="gx-skeleton gx-skeleton--title"></div>' +
            '<div class="gx-skeleton gx-skeleton--text"></div>' +
            '<div class="gx-skeleton-grid">' +
              '<div class="gx-skeleton gx-skeleton--card"></div>' +
              '<div class="gx-skeleton gx-skeleton--card"></div>' +
            '</div>' +
            '<p class="gx-loading-text">Loading your exchange…</p>' +
          '</div>' +
        '</div>' +
      '</div>'
    );
    return fetchJson(PROXY_ROOT + '/exchange-session?token=' + encodeURIComponent(token), {
      method: 'GET',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (result) {
      if (!prop(result, 'valid') || !prop(result, 'session')) {
        renderMessage('Link unavailable', prop(result, 'message') || 'This exchange link is not valid.');
        return;
      }
      state.session = prop(result, 'session');
      state.token = prop(state.session, 'token') || token;
      getOrderLines(state.session).forEach(ensureSelection);
      renderForm();
    });
  }

  function captureFormValues() {
    var notes = document.getElementById('gx-notes');
    var proof = document.getElementById('gx-proof');
    var tracking = document.getElementById('gx-tracking');
    if (notes) state.formValues.notes = String(notes.value || '');
    if (proof) state.formValues.proofNotes = String(proof.value || '');
    if (tracking) state.formValues.returnTracking = String(tracking.value || '');
  }

  function renderSizeChips(lineId, sizes, selectedSizeId, chipClass) {
    if (!sizes || !sizes.length) {
      return '<p class="gx-muted">No other sizes are available right now.</p>';
    }
    var html = '<div class="gx-size-strip" role="listbox" aria-label="Select size">';
    sizes.forEach(function (size) {
      var sizeId = prop(size, 'sizeId');
      var remaining = prop(size, 'remaining');
      var selected = Number(selectedSizeId) === Number(sizeId);
      var unavailable = remaining != null && Number(remaining) <= 0;
      html += '<button type="button"'
        + ' class="' + chipClass + (selected ? ' is-selected' : '') + (unavailable ? ' is-unavailable' : '') + '"'
        + ' data-line="' + lineId + '"'
        + ' data-size-id="' + sizeId + '"'
        + (unavailable ? ' disabled aria-disabled="true"' : '')
        + ' aria-pressed="' + (selected ? 'true' : 'false') + '"'
        + '>'
        + escapeHtml(prop(size, 'sizeName') || ('Size ' + sizeId))
        + '</button>';
    });
    html += '</div>';
    return html;
  }

  function renderOutfitGrid(lineId, catalog, sel) {
    if (!catalog.length) {
      return '<p class="gx-muted">No other outfits are available right now.</p>';
    }

    var html = '<div class="gx-catalog-grid">';
    catalog.forEach(function (item) {
      var productId = prop(item, 'productId') || 0;
      var scheduleItemId = prop(item, 'scheduleItemId') || 0;
      var key = catalogKey(item);
      var selected = Number(sel.replacementProductId) === Number(productId)
        && Number(sel.replacementScheduleItemId) === Number(scheduleItemId);
      var sizes = prop(item, 'sizes') || [];
      var thumb = prop(item, 'thumbUrl') || '';
      var name = prop(item, 'productName') || 'Item';

      html += '<article class="gx-catalog-card' + (selected ? ' is-selected' : '') + '" data-line="' + lineId + '" data-catalog-key="' + escapeHtml(key) + '">';
      html += '<button type="button" class="gx-catalog-media gx-outfit-pick" data-line="' + lineId + '" data-catalog-key="' + escapeHtml(key) + '" aria-pressed="' + (selected ? 'true' : 'false') + '">';
      html += renderThumb(thumb, name, '', 300, 400) || '<span class="gx-catalog-media-empty" aria-hidden="true"></span>';
      if (selected) {
        html += '<span class="gx-catalog-selected-badge">Selected</span>';
      }
      html += '</button>';
      html += '<div class="gx-catalog-info">';
      html += '<p class="gx-catalog-name">' + escapeHtml(name) + '</p>';
      if (selected) {
        html += renderSizeChips(lineId, sizes, sel.replacementSizeId, 'gx-size-chip gx-outfit-size');
        if (sel.replacementSizeId) {
          html += '<p class="gx-added-badge">Size ' + escapeHtml(sizeLabel(sizes, sel.replacementSizeId)) + '</p>';
        } else {
          html += '<p class="gx-added-badge">Select a size</p>';
        }
      } else {
        html += '<p class="gx-muted gx-catalog-hint">Tap to choose</p>';
      }
      html += '</div></article>';
    });
    html += '</div>';
    return html;
  }

  function renderOutfitPreview(catalog, sel) {
    var item = findCatalogItem(catalog, sel.replacementProductId, sel.replacementScheduleItemId);
    if (!item) return '';
    var name = prop(item, 'productName') || 'Item';
    var thumb = prop(item, 'thumbUrl') || '';
    return '<div class="gx-outfit-preview gifting-app-product-row">'
      + (renderThumb(thumb, name, 'gx-line-thumb gifting-app-thumb', 72, 96)
        || '<span class="gx-line-thumb gx-line-thumb--empty gifting-app-thumb" aria-hidden="true"></span>')
      + '<div class="gx-outfit-preview-copy">'
      + '<p class="gx-section-label">Selected outfit</p>'
      + '<p class="gx-catalog-name">' + escapeHtml(name) + '</p>'
      + '</div></div>';
  }

  function renderLineCard(line, catalog) {
    var sel = ensureSelection(line);
    var lineId = prop(line, 'orderLineItemId');
    var sizes = prop(line, 'availableSizes') || [];
    var thumb = prop(line, 'thumbUrl') || '';
    var productName = prop(line, 'productName') || 'Item';
    var sizeName = prop(line, 'sizeName') || '—';
    var qty = prop(line, 'qty') || 1;
    var allowOutfit = allowOutfitExchange();
    var exchangeType = allowOutfit ? sel.exchangeType : TYPE_SIZE;

    var html = '<article class="gx-line' + (sel.enabled ? ' is-open' : '') + '" data-line="' + lineId + '">';
    html += '<div class="gx-line-head">';
    html += '<div class="gx-line-product gifting-app-product-row">';
    html += renderThumb(thumb, productName, 'gx-line-thumb gifting-app-thumb', 72, 96)
      || '<span class="gx-line-thumb gx-line-thumb--empty gifting-app-thumb" aria-hidden="true"></span>';
    html += '<div class="gx-line-copy">';
    html += '<p class="gx-line-label">Gifted item</p>';
    html += '<h2 class="gx-line-name">' + escapeHtml(productName) + '</h2>';
    html += '<p class="gx-line-meta">Size ' + escapeHtml(sizeName) + (qty > 1 ? ' · Qty ' + escapeHtml(qty) : '') + '</p>';
    html += '</div></div>';
    html += '<label class="gx-toggle">';
    html += '<input type="checkbox" class="gx-enable" data-line="' + lineId + '"' + (sel.enabled ? ' checked' : '') + ' />';
    html += '<span class="gx-toggle-ui" aria-hidden="true"></span>';
    html += '<span class="gx-toggle-text">' + (sel.enabled ? 'Exchanging' : 'Exchange') + '</span>';
    html += '</label>';
    html += '</div>';

    if (!sel.enabled) {
      html += '</article>';
      return html;
    }

    html += '<div class="gx-line-body">';
    // Size-only links: no type pills, no outfit UI — size picker only.
    if (allowOutfit) {
      html += '<div class="gx-type-pills" role="tablist" aria-label="Exchange type">';
      html += '<button type="button" class="gx-type-pill' + (exchangeType === TYPE_SIZE ? ' is-active' : '') + '" data-line="' + lineId + '" data-type="' + TYPE_SIZE + '">Different size</button>';
      html += '<button type="button" class="gx-type-pill' + (exchangeType === TYPE_OUTFIT ? ' is-active' : '') + '" data-line="' + lineId + '" data-type="' + TYPE_OUTFIT + '">Different outfit</button>';
      html += '</div>';
    } else {
      sel.exchangeType = TYPE_SIZE;
      exchangeType = TYPE_SIZE;
    }

    if (!allowOutfit || exchangeType === TYPE_SIZE) {
      html += '<div class="gx-panel">';
      html += '<p class="gx-section-label">Choose a new size</p>';
      html += renderSizeChips(lineId, sizes, sel.replacementSizeId, 'gx-size-chip gx-size');
      if (sel.replacementSizeId) {
        html += '<p class="gx-choice-summary">New size: <strong>' + escapeHtml(sizeLabel(sizes, sel.replacementSizeId)) + '</strong></p>';
      }
      html += '</div>';
    } else {
      html += '<div class="gx-panel">';
      html += '<p class="gx-section-label">Choose a replacement outfit</p>';
      html += renderOutfitPreview(catalog, sel);
      html += renderOutfitGrid(lineId, catalog, sel);
      html += '</div>';
    }

    html += '</div></article>';
    return html;
  }

  function enabledCount() {
    var count = 0;
    Object.keys(state.selections).forEach(function (key) {
      if (state.selections[key] && state.selections[key].enabled) count += 1;
    });
    return count;
  }

  function renderForm(errorMessage) {
    var session = state.session;
    var canSubmit = prop(session, 'canSubmit') !== false;
    var lines = getOrderLines(session);
    var catalog = getCatalog(session);
    var name = prop(session, 'influencerName') || 'there';
    var campaign = prop(session, 'campaignName');
    var allowOutfit = allowOutfitExchange();

    var html = '<div class="gx">';
    html += '<div class="gx-shell">';
    html += '<header class="gx-intro">';
    html += '<p class="gx-programme">Gifting programme</p>';
    html += '<h1 class="gx-title">Exchange</h1>';
    html += '<p class="gx-lead">Hi ' + escapeHtml(name);
    if (campaign) html += ' — ' + escapeHtml(campaign);
    html += allowOutfit
      ? '. Choose a different size or another available outfit. This link can only be used once.</p>'
      : '. Choose a different size for your gifted items. This link can only be used once.</p>';
    html += '</header>';

    if (errorMessage) {
      html += '<div class="gx-alert is-error" role="alert">' + escapeHtml(errorMessage) + '</div>';
    }

    if (!canSubmit) {
      html += '<div class="gx-alert is-error">This exchange link is no longer active.</div></div></div>';
      setRoot(html);
      return;
    }

    if (!lines.length) {
      html += '<div class="gx-alert is-error">No exchangeable items were found on this order.</div></div></div>';
      setRoot(html);
      return;
    }

    html += '<section class="gx-lines" aria-label="Gifted order items">';
    lines.forEach(function (line) {
      html += renderLineCard(line, catalog);
    });
    html += '</section>';

    html += '<section class="gx-notes-card">';
    html += '<p class="gx-section-label">Optional details</p>';
    html += '<div class="gx-field"><label class="gx-field-label" for="gx-notes">Notes</label>';
    html += '<textarea id="gx-notes" rows="3" placeholder="Anything we should know">' + escapeHtml(state.formValues.notes) + '</textarea></div>';
    html += '<div class="gx-field"><label class="gx-field-label" for="gx-tracking">Return tracking</label>';
    html += '<input id="gx-tracking" type="text" value="' + escapeHtml(state.formValues.returnTracking) + '" placeholder="Courier tracking number" /></div>';
    html += '<div class="gx-field"><label class="gx-field-label" for="gx-proof">Proof / reason</label>';
    html += '<textarea id="gx-proof" rows="2" placeholder="e.g. size too small">' + escapeHtml(state.formValues.proofNotes) + '</textarea></div>';
    html += '</section>';

    html += '<div class="gx-actions">';
    html += '<button type="button" class="gx-btn-primary" id="gx-submit"' + (state.submitting ? ' disabled aria-busy="true"' : '') + '>';
    html += state.submitting ? 'Submitting…' : (enabledCount() ? 'Submit exchange' : 'Select an item to exchange');
    html += '</button>';
    html += '<p class="gx-disclaimer">' + escapeHtml(stockReleaseDisclaimer()) + '</p>';
    html += '</div>';

    html += '</div></div>';

    var root = setRoot(html);
    bindForm(root);
  }

  function bindForm(root) {
    root.querySelectorAll('.gx-enable').forEach(function (el) {
      el.addEventListener('change', function () {
        captureFormValues();
        var sel = state.selections[selectionKey(el.getAttribute('data-line'))];
        if (!sel) return;
        sel.enabled = el.checked;
        if (!sel.enabled) {
          sel.replacementSizeId = 0;
          if (sel.exchangeType === TYPE_SIZE) {
            sel.replacementProductId = sel.originalProductId;
            sel.replacementScheduleItemId = 0;
          }
        }
        renderForm();
      });
    });

    root.querySelectorAll('.gx-type-pill').forEach(function (el) {
      el.addEventListener('click', function () {
        captureFormValues();
        var sel = state.selections[selectionKey(el.getAttribute('data-line'))];
        if (!sel || !allowOutfitExchange()) return;
        var nextType = el.getAttribute('data-type') === TYPE_OUTFIT ? TYPE_OUTFIT : TYPE_SIZE;
        sel.exchangeType = nextType;
        sel.replacementSizeId = 0;
        if (sel.exchangeType === TYPE_SIZE) {
          sel.replacementProductId = sel.originalProductId;
          sel.replacementScheduleItemId = 0;
        } else {
          sel.replacementProductId = 0;
          sel.replacementScheduleItemId = 0;
        }
        renderForm();
      });
    });

    root.querySelectorAll('.gx-size').forEach(function (el) {
      el.addEventListener('click', function () {
        var sel = state.selections[selectionKey(el.getAttribute('data-line'))];
        if (!sel) return;
        sel.replacementSizeId = parseInt(el.getAttribute('data-size-id'), 10) || 0;
        sel.replacementProductId = sel.originalProductId;
        sel.replacementScheduleItemId = 0;
        renderForm();
      });
    });

    root.querySelectorAll('.gx-outfit-pick').forEach(function (el) {
      el.addEventListener('click', function () {
        if (!allowOutfitExchange()) return;
        captureFormValues();
        var sel = state.selections[selectionKey(el.getAttribute('data-line'))];
        if (!sel) return;
        var parts = (el.getAttribute('data-catalog-key') || '').split(':');
        sel.exchangeType = TYPE_OUTFIT;
        sel.replacementProductId = parseInt(parts[0], 10) || 0;
        sel.replacementScheduleItemId = parseInt(parts[1], 10) || 0;
        sel.replacementSizeId = 0;
        renderForm();
      });
    });

    root.querySelectorAll('.gx-outfit-size').forEach(function (el) {
      el.addEventListener('click', function () {
        if (!allowOutfitExchange()) return;
        var sel = state.selections[selectionKey(el.getAttribute('data-line'))];
        if (!sel) return;
        sel.replacementSizeId = parseInt(el.getAttribute('data-size-id'), 10) || 0;
        renderForm();
      });
    });

    var submitBtn = root.querySelector('#gx-submit');
    if (submitBtn) submitBtn.addEventListener('click', submitExchange);
  }

  function submitExchange() {
    if (state.submitting) return;
    captureFormValues();
    var lines = [];
    var incomplete = false;
    var allowOutfit = allowOutfitExchange();
    Object.keys(state.selections).forEach(function (key) {
      var sel = state.selections[key];
      if (!sel || !sel.enabled) return;
      var exchangeType = allowOutfit ? sel.exchangeType : TYPE_SIZE;
      var productId = exchangeType === TYPE_SIZE
        ? sel.originalProductId
        : sel.replacementProductId;
      var scheduleItemId = exchangeType === TYPE_SIZE ? 0 : (sel.replacementScheduleItemId || 0);
      if (!sel.replacementSizeId || !productId) {
        incomplete = true;
        return;
      }
      lines.push({
        ExchangeType: exchangeType,
        OriginalOrderLineItemId: sel.originalOrderLineItemId,
        ReplacementProductId: productId || 0,
        ReplacementScheduleItemId: scheduleItemId,
        ReplacementSizeId: sel.replacementSizeId,
        ReplacementQty: sel.replacementQty || 1
      });
    });

    if (incomplete || !lines.length) {
      renderForm(incomplete
        ? 'Choose a replacement item and size for every selected exchange.'
        : 'Select at least one item and choose a replacement size.');
      return;
    }

    var payload = {
      Token: state.token,
      Notes: state.formValues.notes.trim(),
      ProofNotes: state.formValues.proofNotes.trim(),
      ReturnTracking: state.formValues.returnTracking.trim(),
      Lines: lines
    };

    state.submitting = true;
    renderForm();
    fetchJson(PROXY_ROOT + '/exchange-submit', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (result) {
        state.submitting = false;
        if (prop(result, 'success') || prop(result, 'ok')) {
          renderMessage(
            'Exchange submitted',
            prop(result, 'message') || 'Thanks — we have your exchange request and updated event stock.',
            true
          );
        } else {
          renderForm(prop(result, 'message') || 'Unable to submit. Please try again.');
        }
      })
      .catch(function (error) {
        state.submitting = false;
        renderForm(error instanceof Error ? error.message : 'Something went wrong. Please try again.');
      });
  }

  function boot() {
    var token = queryParam('token');
    if (!token) {
      renderMessage('Missing link', 'This exchange link is incomplete. Please use the full link from the SABO team.');
      return;
    }
    state.token = token;
    loadSession(token).catch(function (error) {
      renderMessage(
        'Unable to load exchange',
        error instanceof Error ? error.message : 'Unable to load your exchange. Please try the link again.'
      );
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})(window, document);
